import * as React from 'react';
import * as styles from './styles.css';
import { throttle } from 'throttle-debounce';
import { EEstimationTargets } from '@cian/valuation-main-filters-widget';

import { ValuationFiltersSubmitLayout } from './ValuationFiltersSubmitLayout';

export interface IValuationFiltersSubmitStoreProps {
  isFetching?: boolean;
  isNotFound?: boolean;
  isEstimationReady?: boolean;
  buttonText: string;
  estimationTarget: EEstimationTargets;
}

export interface IValuationFiltersSubmitDispatchProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  onEstimationReadyClick(): void;
}

export type TProps = IValuationFiltersSubmitStoreProps & IValuationFiltersSubmitDispatchProps;

/**
 * Расстояние от контейнера до края окна браузера
 */
const MAX_BOTTOM_OFFSET = 20;

export class ValuationFiltersSubmit extends React.Component<TProps> {
  private htmlContainer = React.createRef<HTMLDivElement>();

  public componentDidMount() {
    /* istanbul ignore else */
    if (this.htmlContainer.current) {
      this.changeShadow();

      document.addEventListener('scroll', this.handleScroll);
    }
  }

  public componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  private changeShadow = () => {
    /* istanbul ignore else */
    if (this.htmlContainer.current) {
      const container = this.htmlContainer.current;
      const bottomOffset = window.innerHeight - container.getBoundingClientRect().bottom;

      if (bottomOffset > MAX_BOTTOM_OFFSET) {
        container.classList.remove(styles['shadow']);
      } else {
        container.classList.add(styles['shadow']);
      }
    }
  };

  private handleScroll = throttle(200, this.changeShadow);

  public render() {
    const { isFetching, buttonText } = this.props;

    return (
      <ValuationFiltersSubmitLayout
        buttonText={buttonText}
        containerRef={this.htmlContainer}
        onClick={this.props.onClick}
        onEstimationReadyClick={this.props.onEstimationReadyClick}
        isFetching={isFetching}
        isNotFound={this.props.isNotFound}
        isEstimationReady={this.props.isEstimationReady}
      />
    );
  }
}
